export const topBarHeight = 70;
export const mainNavWidth = 240;
export const logoContainerHeight = '90px';
export const quickMessageDuration = 5000; // how long a quick message is displayed for, in ms
export const quickMessageFadeOutDuration = 300; // how long a quick message takes to fade out, in ms
export const emailValidationPattern = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,63}$/i;
export const typingDebounceTimeout = 300;
export const actionButtonDebounceTimeout = 500;


// WEBPACK FOOTER //
// ./src/theme/uiConfig.js